import { 
    SELECT_ADMIN_FINANCE_TAB
  } from './constants';

export const selectFinanceTab = (financeTab) => ({
    type: SELECT_ADMIN_FINANCE_TAB,
    payload: financeTab
  });


// WEBPACK FOOTER //
// ./src/features/finance/actionTypes.js